import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/batch/work-orders',
    name: 'PUT_PRODUCTION_ORDERS',
    method: 'PUT',
  });

  return [exec, isRequestSuccessed];
});
